import { createAction } from '@reduxjs/toolkit';

export const setCountry = createAction('geoip/set_country');
export const setPopupShown = createAction('geoip/set_popup_shown');
